import React from "react";
import { Container, Icon, Title, Description } from "./styles";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";
import PropTypes from "prop-types";

const BulletWithIconAndDescription = ({
	title,
	description,
	isBulletRichText,
	imgUrl,
	altTag,
}) => (
	<Container>
		<Icon>
			<CloudinaryImage
				url={imgUrl}
				quality="auto"
				lazyload
				fetchFormat="auto"
				drp="1.0"
				sizes={{
					default: {
						width: 27,
					},
					"322px": {
						width: 27,
					},
				}}
				alt={altTag}
			/>
		</Icon>
		<div>
			<Title>{title}</Title>
			{isBulletRichText ? (
				<Description
					className="html-content"
					dangerouslySetInnerHTML={{ __html: description }}
				></Description>
			) : (
				<Description>{description}</Description>
			)}
		</div>
	</Container>
);

BulletWithIconAndDescription.defaultProps = {
	title: "",
	description: "",
	imgUrl: "",
	altTag: "",
};

BulletWithIconAndDescription.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	imgUrl: PropTypes.string,
	altTag: PropTypes.string,
};
export default BulletWithIconAndDescription;
